<script setup>
import ProhibitIcon from '@iconify-vue/ph/prohibit';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';
import { useRoute } from '@js/utils/route';
import { toastError, toastSuccess } from '@js/utils/toast';
import { computed, ref } from 'vue';

const { selectionIds, count, globalFilter, filters, data, callback } =
    defineProps({
        selectionIds: {
            type: Array,
            required: true,
        },
        count: {
            type: Number,
            required: true,
        },
        globalFilter: {
            type: String,
            required: false,
        },
        filters: {
            type: Array,
            required: false,
        },
        data: {
            type: Object,
            required: false,
        },
        callback: {
            type: Function,
            required: false,
        },
    });

const { route } = useRoute();

const isOpen = ref(false);

const isLoading = ref(false);

const confirmationText = computed(() =>
    count > 1
        ? `${count} appels vont passer en « ignoré » et quitteront la file à traiter.`
        : `1 appel va passer en « ignoré » et quittera la file à traiter.`,
);

function ignorePhoneCalls() {
    isLoading.value = true;

    axios
        .post(route('front.projectManagement.apikom.postIgnorePhoneCalls'), {
            selectionIds,
            globalFilter,
            filters,
            data,
        })
        .then((response) => {
            isOpen.value = false;

            toastSuccess(
                `${response.data.count} appel${response.data.count > 1 ? 's' : ''} ignoré${response.data.count > 1 ? 's' : ''}.`,
            );

            if (callback) {
                callback();
            }
        })
        .finally(() => {
            isLoading.value = false;
        })
        .catch((error) => {
            toastError(error);
        });
}
</script>

<template>
    <DialogModal v-model="isOpen" size="small">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Ignorer les appels sélectionnés </template>

        <template #content>
            {{ confirmationText }}
        </template>

        <template #footer>
            <div class="flex justify-end gap-2">
                <ActionButton
                    type="transparent"
                    :callback="() => (isOpen = false)"
                >
                    Annuler
                </ActionButton>

                <ActionButton
                    type="danger"
                    :left-icon="ProhibitIcon"
                    :callback="() => ignorePhoneCalls()"
                    :loading="isLoading"
                >
                    Ignorer
                </ActionButton>
            </div>
        </template>
    </DialogModal>
</template>
